import {
  useCreateTransformationMutation,
  useUpdateTransformationMutation,
  useLazyGetTransformationQuery,
} from "../store/services/transformationQuery";

export const useTransformation = () => {
  const [
    createTransformation,
    {
      data: createTransformationData,
      isLoading: createTransformationIsLoading,
      isError: createTransformationIsError,
      error: createTransformationError,
      isSuccess: createTransformationIsSuccess,
    },
  ] = useCreateTransformationMutation();

  const [
    updateTransformation,
    {
      data: updateTransformationData,
      isLoading: updateTransformationIsLoading,
      isError: updateTransformationIsError,
      error: updateTransformationError,
      isSuccess: updateTransformationIsSuccess,
    },
  ] = useUpdateTransformationMutation();
  const [
    getTransformation,
    {
      data: getTransformationData,
      isLoading: getTransformationIsLoading,
      isError: getTransformationIsError,
      error: getTransformationError,
      isSuccess: getTransformationIsSuccess,
    },
  ] = useLazyGetTransformationQuery();

  return {
    createTransformation,
    createTransformationData,
    createTransformationIsLoading,
    createTransformationIsError,
    createTransformationError,
    createTransformationIsSuccess,
    updateTransformation,
    updateTransformationData,
    updateTransformationIsLoading,
    updateTransformationIsError,
    updateTransformationError,
    updateTransformationIsSuccess,
    getTransformation,
    getTransformationData,
    getTransformationIsLoading,
    getTransformationIsError,
    getTransformationError,
    getTransformationIsSuccess,
  };
};
